import {makeFactAddressItems} from "../helpers/fact-address-items.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

export default function FactAddress({ title, data, printOptions }) {
    const cityFact = makeFactAddressItems(data);

    return (
        <>
            <InfoGrid title={title} items={cityFact} />
        </>
    )
}